import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.notice.list');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-gsdcuser-notice-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.notice.list/view.scss */
/* src/app/portal.gsdcuser.notice.list/view.scss: no such file or directory */`],
})
export class PortalGsdcuserNoticeListComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service) { }

    public boards: any = [];
    public loaded: boolean = false;

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1
    };
    public total: any = 0;
    public mode: any = "";
    public searchTerm: any;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, mode: this.mode });
        if (code != 200) return await this.service.alert.error("Error!");
        this.boards = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }
}

export default PortalGsdcuserNoticeListComponent;